var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6875 3.75C12.5243 3.75 10.4096 4.39147 8.61096 5.5933C6.81229 6.79513 5.41041 8.50333 4.58257 10.5019C3.75474 12.5005 3.53814 14.6996 3.96017 16.8213C4.38219 18.943 5.42389 20.8918 6.95352 22.4215C8.48316 23.9511 10.432 24.9928 12.5537 25.4148C14.6754 25.8369 16.8745 25.6203 18.8731 24.7924C20.8717 23.9646 22.5799 22.5627 23.7817 20.764C24.9835 18.9654 25.625 16.8507 25.625 14.6875C25.6184 11.7887 24.4639 9.01056 22.4142 6.96081C20.3644 4.91106 17.5863 3.7566 14.6875 3.75ZM20.5625 12.1875L14.3125 18.4375C14.1367 18.6131 13.8984 18.7117 13.65 18.7117C13.4016 18.7117 13.1633 18.6131 12.9875 18.4375L8.8125 14.3125C8.63694 14.1367 8.53833 13.8984 8.53833 13.65C8.53833 13.4016 8.63694 13.1633 8.8125 12.9875C8.89869 12.8991 9.00171 12.8288 9.11549 12.7808C9.22927 12.7328 9.35151 12.708 9.475 12.708C9.5985 12.708 9.72074 12.7328 9.83452 12.7808C9.9483 12.8288 10.0513 12.8991 10.1375 12.9875L13.65 16.4875L19.2375 10.9375C19.3077 10.814 19.405 10.7081 19.5221 10.6278C19.6392 10.5475 19.7731 10.4948 19.9135 10.4737C20.054 10.4527 20.1974 10.4638 20.3329 10.5063C20.4684 10.5488 20.5925 10.6215 20.6958 10.7189C20.7991 10.8164 20.8789 10.936 20.9292 11.0689C20.9795 11.2017 20.999 11.3442 20.9861 11.4856C20.9733 11.6271 20.9285 11.7637 20.8551 11.8853C20.7817 12.0069 20.6817 12.1102 20.5625 12.1875Z",
    fill: "#54CB8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.c910914f1c1f29c48c8fd2269e0558e7.svg";
export { ForwardRef as ReactComponent };